import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getExpenses(params: any): AxiosPromise {
    return EndPointService.get('/expenses', { params });
}

function getExpense(id: number | string): AxiosPromise {
    return EndPointService.get(`/expenses/${id}`);
}

function deleteExpense(id: number | string): AxiosPromise {
    return EndPointService.delete(`/expenses/${id}`);
}

function createExpense(payload: any): AxiosPromise {
    return EndPointService.post('/expenses', payload);
}

function updateExpense(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/expenses/${id}`, { ...payload });
}

export default {
    getExpenses,

    getExpense,
    deleteExpense,
    createExpense,
    updateExpense,
};
